import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import ClientsList from "@src/views/ClientPage/ClientsList";
import PageTitle from "@src/components/PageTitle";
import {
  WithSnackbarProps,
  withSnackbar,
} from "@src/components/SnackBarComponent";
import { useMyClientsQuery } from "@src/queries/clients";

const columns = [
  { id: "Common.UserNumber", minWidth: 100 },
  { id: "Common.LastName", minWidth: 170 },
  { id: "Common.FirstName", minWidth: 170 },
  { id: "Common.Email", minWidth: 100 },
];
const MyClientsView: FC<WithSnackbarProps> = ({ snackbarShowMessage }) => {
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const { data, isFetching, refetch } = useMyClientsQuery({
    page,
    search,
  });
  const { t } = useTranslation();

  return (
    <>
      <PageTitle title={t("MyClients.Pagetitle")} />
      <ClientsList
        data={data}
        isFetching={isFetching}
        refetchData={refetch}
        page={page}
        setPage={setPage}
        setSearch={setSearch}
        columns={columns}
        snackbarShowMessage={snackbarShowMessage}
      />
    </>
  );
};

export default withSnackbar(MyClientsView);
